import { render, staticRenderFns } from "./OutsourcingContactListEdit.vue?vue&type=template&id=52d2657b&scoped=true&"
import script from "./OutsourcingContactListEdit.vue?vue&type=script&lang=js&"
export * from "./OutsourcingContactListEdit.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcingContactListEdit.vue?vue&type=style&index=0&id=52d2657b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2657b",
  null
  
)

export default component.exports